module.exports = __webpack_public_path__ + "img/image003.51f4b227.jpg";